import { render } from "./ly.vue?vue&type=template&id=d6000c5e&scoped=true"
import script from "./ly.vue?vue&type=script&lang=js"
export * from "./ly.vue?vue&type=script&lang=js"

import "./ly.vue?vue&type=style&index=0&id=d6000c5e&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6000c5e"]])

export default __exports__